export default __webpack_public_path__ + "94c9975f6e01262208695d470dc57b8d.svg";